import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-flex justify-content-end page-heading-toolbar" }
const _hoisted_3 = { class: "page-heading-toolbar--col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BtnContent = _resolveComponent("BtnContent")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_PageMainHeading = _resolveComponent("PageMainHeading")!
  const _component_CategoryTable = _resolveComponent("CategoryTable")!
  const _component_AppTableController = _resolveComponent("AppTableController")!
  const _component_CategoryModal = _resolveComponent("CategoryModal")!
  const _component_DeleteBrandDialog = _resolveComponent("DeleteBrandDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageMainHeading, { title: "Categories" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_AppButton, {
                type: "secondary",
                size: "lg",
                onClick: _ctx.editingCategory
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BtnContent, {
                    icon: "plus",
                    label: "Create Category"
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_AppTableController, {
      "show-table": !!_ctx.categoryList.length,
      "empty-button-text": "Create Operator",
      "empty-key": "category",
      "empty-icon": "category",
      onEmptyButtonClick: _ctx.editingCategory
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CategoryTable, {
          "categories-list": _ctx.categoryList,
          "total-rows-count": _ctx.totalAccountsCount,
          "initial-view-configuration": _ctx.viewConfiguration,
          sort: _ctx.sortConfig,
          onChangeViewConfiguration: _ctx.changeViewConfigurationHandler,
          onRemovingCategory: _ctx.removingCategory,
          onEditingCategory: _ctx.editingCategory
        }, null, 8, ["categories-list", "total-rows-count", "initial-view-configuration", "sort", "onChangeViewConfiguration", "onRemovingCategory", "onEditingCategory"])
      ]),
      _: 1
    }, 8, ["show-table", "onEmptyButtonClick"]),
    _createVNode(_component_CategoryModal, {
      title: _ctx.editData?.id ? 'Edit Category' : 'Add category',
      loading: _ctx.isLoading,
      data: _ctx.editData?.id ? _ctx.editData : null,
      opened: _ctx.createCategoryOpened,
      "create-data": _ctx.editData,
      onHide: _ctx.cleanData,
      onCancel: _ctx.cleanData,
      onSubmit: _ctx.actionWithCategory
    }, null, 8, ["title", "loading", "data", "opened", "create-data", "onHide", "onCancel", "onSubmit"]),
    _createVNode(_component_DeleteBrandDialog, {
      title: _ctx.editData?.title,
      opened: _ctx.deleteCategoryOpened,
      loading: _ctx.isLoading,
      photo: _ctx.editData?.icon,
      "edit-data": _ctx.editData,
      "is-show": true,
      onHide: _ctx.cleanData,
      onConfirm: _ctx.onDeleteConfirm,
      onCancel: _ctx.cleanData
    }, null, 8, ["title", "opened", "loading", "photo", "edit-data", "onHide", "onConfirm", "onCancel"])
  ], 64))
}